import { ISiteCreateModel } from "@/Administration/Models/UI/Sites/ISiteCreateModel";
import { ISitesTabModel } from "@/Administration/Models/UI/Sites/ISitesTabModel";
import { ISiteViewModel } from "@/Administration/Models/UI/Sites/ISiteViewModel";
import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { Popup } from "@/Common/Components/Modals/Popup";
import { SitesModel } from "@/Common/Models/Sites/SitesModel";
import { SitesUIState } from "@/Common/Models/UI/Enums";
import * as LocalOperations from "@/Common/Operations/operations.local";
import SiteCreate from "./SiteCreate";
import { SiteView } from "./SiteView";

interface ISitesTabProps {
    model: ISitesTabModel;
    selectedSite: ISiteViewModel;
    createSiteModel: ISiteCreateModel;
}

class SitesTab extends React.Component<ISitesTabProps> {
    public render(): JSX.Element {
        const { selectedSite, createSiteModel, model } = this.props;

        let sitesToDisplay = model.get("Sites").toArray();
        if (!IsNullOrWhiteSpace(model.get("SearchText"))) {
            const filteredSites = model.get("Sites").toArray().filterSearch(model.get("SearchText"), s => s.Model.ClinicalName);
            sitesToDisplay = sitesToDisplay.filter(x => filteredSites.some(f => f.Model.Id === x.Model.Id) || filteredSites.some(f => f.Model.ParentSiteId === x.Model.Id));
        }

        return (
            <div id="SitesTab" className="fxheight">
                <div className="fxheight transition full-border admin-users-search" style={{ float: "left" }}>

                    <div className="user-search">
                        <div className="flex-container s">
                            <div className="search-field" style={{ width: "100%", maxHeight: "40px" }}>
                                <div className="gf">
                                    <span className="glyphicon glyphicon-search" />
                                </div>
                                <div style={{ width: "100%" }}>
                                    <TextboxControl
                                        onMountFocus={true}
                                        debounceMs={400}
                                        value={this.props.model.get("SearchText") ? this.props.model.get("SearchText") : ""}
                                        name="text_search_users"
                                        className="fullWidth"
                                        operation={LocalOperations.Sites.LoadSites}
                                        placeholder={cacheStore.GetString("SearchLabel")}
                                        autoComplete="off"
                                        autoCompleteItems={null}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="patient-create-options flex-container">
                            <div>
                                <a onClick={e => this.onAddOrganizationClick(e)}>{cacheStore.GetString("AddOrganizationLabel")}</a>
                            </div>
                            <div className="text-right">
                                <a onClick={e => this.onAddNewSiteClick(e)}>{cacheStore.GetString("AddNewSiteLabel")}</a>
                            </div>
                        </div>
                    </div>

                    <div className="fxheight user-search-results scrollable" style={{ minHeight: "778px" }}>
                        <div className="pointer">
                            {sitesToDisplay.map((x, i: number) => {
                                let selectedClass = "";
                                if (selectedSite && selectedSite.get("Model") != null) {
                                    selectedClass = (x.Model.Id == selectedSite.get("Model").Id) ? " selected" : "";
                                }

                                return (
                                    <div
                                        className={"user-search-item" + selectedClass}
                                        id={"__a" + i}
                                        key={i + "___rr"}
                                        onClick={() => this.openSelectedSite(x)}
                                        title={x.Model.ClinicalName}
                                    >
                                        {IsNullOrWhiteSpace(x.Model.ParentSiteId) && (
                                            <div className="flex-container medical-note" style={{ fontWeight: "bold" }}>
                                                {limitTextLength(x.Model.ClinicalName, 35)}
                                            </div>
                                        )}
                                        {!IsNullOrWhiteSpace(x.Model.ParentSiteId) && (
                                            <div style={{ paddingLeft: "15px" }} className="flex-container medical-note">
                                                {limitTextLength(x.Model.ClinicalName, 35)}
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>

                <div style={{ marginLeft: "290px" }}>
                    {model.get("IsDuplicateWarningOpen") && (
                        <Popup Id="duplicate-site" title={cacheStore.GetString("WarningLabel")} onCloseDelegate={() => sessionStore.dispatch(LocalOperations.Sites.CloseDuplicatePopup)}>
                            <div className="p-body">
                                {cacheStore.GetString("ProceedSiteMessageLabel")}
                            </div>
                            <div className="p-footer">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12 columns flex-display flex-gap-xs flex-end">
                                        <ButtonControl
                                            className="btn btn-default"
                                            onClick={() => sessionStore.dispatch(LocalOperations.Sites.CloseDuplicatePopup)}
                                            label={cacheStore.GetString("CloseLabel")}
                                        />
                                        <ButtonControl
                                            variant="brand"
                                            onClick={() => sessionStore.dispatch(LocalOperations.Sites.ProceedClick)}
                                            label={cacheStore.GetString("ProceedLabel")}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Popup>
                    )}
                    {model.get("UIStateChange") === SitesUIState.View &&
                        selectedSite != null && !IsNullOrWhiteSpace(selectedSite.get("Model").ClinicalName) && (
                            <SiteView model={selectedSite} />
                    )
                    }

                    {model.get("UIStateChange") === SitesUIState.Create && (
                        <SiteCreate
                            model={createSiteModel}
                            titleLabel={createSiteModel.get("Title")}
                            infoLabel={createSiteModel.get("InfoLabel")}
                            selectedSite={selectedSite.get("Model")}
                        />
                    )}
                </div>
            </div>
        );
    }

    public componentDidMount(): void {
        $(window).trigger("resize");
        sessionStore.dispatch(LocalOperations.Sites.LoadSites);
    }

    public componentDidUpdate(): void {
        $(window).trigger("resize");
    }

    public openSelectedSite(site: SitesModel): void {
        sessionStore.dispatch(LocalOperations.Sites.OpenSelectedSite, { site: site });
    }

    public onAddNewSiteClick(e: React.MouseEvent): void {
        e.preventDefault();
        sessionStore.dispatch(LocalOperations.Sites.AddNewSite);
    }

    public onAddOrganizationClick(e: React.MouseEvent): void {
        e.preventDefault();
        sessionStore.dispatch(LocalOperations.Sites.AddOrganization);
    }
}

export { ISitesTabProps };
export default SitesTab;
